import { createBrowserHistory } from "history";
import { getBasePath } from "./getBasePath.js";
import { getUserConfirmation, historyExtended } from "./internal/historyExtended.js";
import { getV2RuntimeFromDll } from "./getV2RuntimeFromDll.js";
let history;
export function createHistory() {
  if (!history) {
    // https://github.com/remix-run/history/issues/810
    const browserHistory = createBrowserHistory({
      basename: getBasePath().replace(/\/$/, ""),
      getUserConfirmation
    });
    Object.assign(browserHistory, historyExtended(browserHistory));
    history = browserHistory;
  }
  return history;
}
function getHistoryV3() {
  return history;
}

/**
 * When using v3 bricks in v2 container, return history from v2 container.
 */
function getHistoryV2Factory() {
  const v2Kit = getV2RuntimeFromDll();
  if (v2Kit) {
    return v2Kit.getHistory;
  }
}
export const getHistory = getHistoryV2Factory() || getHistoryV3;
//# sourceMappingURL=history.js.map